export default __webpack_public_path__ + "static/media/21t.c4b0f414.jpg";